import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_PUBLIC_MEDREFILL_CLINIC_LIST_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type { GetClinicListResult, GetPublicClinicListPayload } from '../types/getClinicList.type';

export const TAG_PUBLIC_MEDREFILL_CLINIC_LIST = 'getPublicClinicList';
export const getPublicClinicList = <T extends BuilderType>(builder: T) =>
  builder.query<GetClinicListResult, GetPublicClinicListPayload>({
    providesTags: [TAG_PUBLIC_MEDREFILL_CLINIC_LIST],
    query: (params) => ({
      data: params,
      method: 'POST',
      url: GET_PUBLIC_MEDREFILL_CLINIC_LIST_URL,
    }),
    transformResponse: (response: GenericApiResponse<GetClinicListResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }
      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
